// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__KaFZ9","sendOtp":"AuthorizeToLogin_sendOtp__3gWPj"};